module.exports = __webpack_public_path__ + "static/media/nodejs.4b12dd41.png";